export default "/images/vendor/flag-icons/flags/1x1/tt.svg?62c94980596e2af8b861623ab21ebeba";